import { z } from "zod";

export const recruitPositionGenerateFormMethodSchema = z.enum([
	"webSiteUrl",
	"textInput",
]);

export const recruitPositionGenerateFormSchema = z.discriminatedUnion(
	"method",
	[
		z.object({
			method: z.literal(
				recruitPositionGenerateFormMethodSchema.enum.webSiteUrl,
			),
			webSiteUrl: z
				.string({
					required_error: "URLを入力してください",
				})
				.url({
					message: "正しいURLを入力してください",
				}),
		}),
		z.object({
			method: z.literal(recruitPositionGenerateFormMethodSchema.enum.textInput),
			textInput: z
				.string({
					required_error: "求人内容を入力してください",
				})
				.trim()
				.min(100, {
					message: "求人内容は100文字以上入力してください",
				})
				.max(5000, {
					message: "5000文字以内で入力してください",
				}),
			title: z
				.string({
					required_error: "選考基準名を入力してください",
				})
				.trim()
				.min(1, {
					message: "選考基準名を入力してください",
				})
				.max(50, {
					message: "50文字以内で入力してください",
				}),
		}),
	],
);

export type RecruitPositionGenerateForm = z.infer<
	typeof recruitPositionGenerateFormSchema
>;
